import $ from "jquery";

$(".promo-box.lux-clickable").each(function () {
    $(this).on("click", function () {
        $(this).find(".btn")[0].click();
    });
});
